import { useLockBodyScroll } from 'react-use';
import { AnimatePresence, motion, type HTMLMotionProps } from 'framer-motion';
import { SafeAny, tlwTwMerge } from '@trg/utils';

export type BackdropProps = Omit<HTMLMotionProps<'div'>, 'children'> & {
  name: string;
  open: boolean;
  zIndex?: number;
  canChangeBodyOverFlow?: boolean;
};

export function Backdrop({
  name,
  open,
  className,
  zIndex,
  style,
  canChangeBodyOverFlow,
  ...props
}: BackdropProps) {
  if (canChangeBodyOverFlow) {
    document.body.style['overflow' as SafeAny] = 'hidden';
  } else {
    document.body.style['overflow' as SafeAny] = 'auto';
  }

  return (
    <AnimatePresence key={`${name}-backdrop`}>
      {open && (
        <motion.div
          className={tlwTwMerge(
            'tlw-fixed tlw-inset-0 tlw-cursor-pointer tlw-bg-black/50 lg:tlw-bg-black/35',
            className
          )}
          style={{
            zIndex,
            ...style,
          }}
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.3 }}
          {...props}
        />
      )}
    </AnimatePresence>
  );
}
